import { QueryClient } from '@tanstack/react-query';
import { HttpError } from '../api/http';

export const QUERY_STALE_TIME_MS = 15_000;
export const QUERY_GC_TIME_MS = 60_000;
const MAX_QUERY_RETRIES = 1;
const HTTP_SERVER_ERROR = 500;

export function retryQuery(failureCount: number, error: Error) {
  if (error.name === 'AbortError' || failureCount >= MAX_QUERY_RETRIES) return false;
  return error instanceof HttpError
    ? error.status >= HTTP_SERVER_ERROR
    : error.cause instanceof TypeError;
}
/** A new client per authenticated session. Never persist protected responses to browser storage. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        gcTime: QUERY_GC_TIME_MS,
        retry: retryQuery,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}
